<!--
 * @Descripttion: 
 * @Author: Junteng Shi
 * @Date: 2025-05-19 15:46:01
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-08-21 10:16:43
-->
<template>
  <div class="relative w-full h-full" p-24px>
    <img src="@/assets/images/title.png" alt="" />
    <div font-600 font-size-20px class="c-#2130C8" line-height-30px mb-20px>后台管理系统</div>
    <div class="w-4px absolute left-0 top-0 bg-#1F31E7 h-16px sidebar" :style="{ top: activeTop }"></div>
    <div v-for="(item, index) in menuItems" :key="item.label" class="w-full h-52px flex items-center cursor-pointer"
      :class="[currentPath === item.path ? 'text-#1F31E7' : 'text-#343434']" @click="handleClick(index)">
      <svg-icon :name="`svg-${item.icon}`" :color="currentPath === item.path ? '#1F31E7' : '#343434'" size="custom-24px"
        mr-16px></svg-icon>
      <!-- <img :src="item.icon" alt="menu-icon" class="w-24px h-24px mr-16px" /> -->
      <span>{{ item.name }}</span>
    </div>
    <el-dropdown trigger="click" class="absolute left-24px bottom-24px">
      <div class="flex items-center bg-#fff bg-op-50 b-rd-52px p-3px pr-10px">
        <span class="el-dropdown-link flex items-center space-x-2">
          <img :src="userAvatar" alt="User Avatar" class="rounded-full w-30px h-30px cursor-pointer"
            @error="(e) => (e.target.src = defAvatar)" />
          <span class="font-medium c-#000">{{ username }}</span>
        </span>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="openPasswordDialog">修改密码</el-dropdown-item>
          <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <el-dialog v-model="pwVisible" title="修改密码" width="500px" :before-close="closeDialog">
      <el-form ref="ruleFormRef" :model="pwForm" status-icon :rules="rules" label-width="130px">
        <el-form-item label="原密码" prop="oldPW">
          <el-input style="width: 240px" v-model="pwForm.oldPW" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPW">
          <el-input style="width: 240px" v-model="pwForm.newPW" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPW">
          <el-input style="width: 240px" v-model="pwForm.checkPW" type="password" autocomplete="off" />
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="text-center">
          <el-button type="primary" @click="submitPW(ruleFormRef)" :loading="submitLoading"> 确定 </el-button>
          <el-button @click="closeDialog">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { changePassword } from '@/api/user/index';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore, useUserStore } from '@/store';
import defAvatar from '@/assets/images/default-avatar.png';
import type { FormInstance, FormRules } from 'element-plus';

const appStore = useAppStore();
const ruleFormRef = ref<FormInstance>();

// 菜单项数据
const menuItems = ref<any[]>([]);
menuItems.value = appStore.$state.menuList?.children;

// 当前选中的菜单索引
const currentIndex = ref(0);

// 计算蓝色竖条的 top 值
const activeTop = computed(() => `${currentIndex.value * 52 + 130}px`);

const currentPath = ref('');
const route = useRoute();
const router = useRouter();

watch(
  () => route.path,
  (newPath) => {
    currentPath.value = newPath.split('/')[1];
    currentIndex.value = menuItems.value && menuItems.value.findIndex((item) => item.path === currentPath.value);
  },
  { immediate: true },
);

// 点击菜单项时更新 currentIndex
const handleClick = (index: number) => {
  currentIndex.value = index;
  // router.push({ name: menuItems.value[index].path as any });
  router.push(`${menuItems.value[index].path}`);
};

const userStore = useUserStore();
const username = ref('用户名'); // 用户名
const userAvatar = ref('');
onMounted(() => {
  username.value = userStore.$state.role.realName;
  userAvatar.value = defAvatar;
});
const logout = () => {
  ElMessageBox.confirm('确定要退出登录吗？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
    autofocus: false,
  })
    .then(async () => {
      userStore.logout();
    })
    .catch((error) => {
      console.error('退出登录失败', error);
    });
};

const pwForm = reactive({
  newPW: '',
  oldPW: '',
  checkPW: '',
});
const validatePass = (_: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入新密码'));
  } else {
    if (pwForm.checkPW !== '') {
      if (!ruleFormRef.value) return;
      ruleFormRef.value.validateField('checkPW', () => null);
    }
    callback();
  }
};
const validatePass2 = (_: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请确认密码'));
  } else if (value !== pwForm.newPW) {
    callback(new Error('密码不一致!'));
  } else {
    callback();
  }
};

const validateOldPass = (_: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入旧密码'));
  } else {
    callback();
  }
};

const rules = reactive<FormRules<typeof pwForm>>({
  oldPW: [{ validator: validateOldPass, trigger: 'blur' }],
  newPW: [{ validator: validatePass, trigger: 'blur' }],
  checkPW: [{ validator: validatePass2, trigger: 'change' }],
});
const pwVisible = ref<boolean>(false);
const openPasswordDialog = () => {
  pwVisible.value = true;
};

const closeDialog = () => {
  pwVisible.value = false;
  ruleFormRef.value!.resetFields();
};

const submitLoading = ref<boolean>(false);
const submitPW = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      submitLoading.value = true;
      await changePassword({
        // userId: userStore.$state.role.id,
        oldPassword: pwForm.oldPW,
        newPassword: pwForm.newPW,
      }).finally(() => {
        submitLoading.value = false;
      });
      ElMessage.success('修改成功');
      closeDialog();
      // 退出登录
      userStore.logout();
    }
  });
};
</script>

<style scoped>
.sidebar {
  transition: all 0.2s linear;
}

.menu-item.active {
  background-color: #f0f0f0;
  /* 选中状态背景色 */
}

.menu-label {
  transition: all 0.2s linear;
}
</style>
